module.exports = __webpack_public_path__ + "static/media/socialt.44386298.svg";